const theme = {
  font: {
    size: {
      DEFAULT: '1rem',
      '2xs': '0.625rem',
      xs: '0.75rem',
      sm: '0.875rem',
      md: '1.125rem',
      lg: '1.5rem',
      xl: '2rem',
      '2xl': '2.5rem',
    },
    weight: {
      light: 300,
      normal: 400,
      medium: 500,
      semibold: 600,
      bold: 700,
    },
    lineHeight: {
      DEFAULT: '140%',
      md: '1.5rem',
      lg: '2rem',
      xl: '2.5rem',
      '2xl': '3rem',
    },
  },
  color: {
    primary: '#69CE8C',
    success: '#69CE8C',
    notice: '#F2C94C',
    warning: '#FFB3C3',
    danger: '#D83D29',

    brand: {
      primary: '#69CE8C',
    },

    black: {
      DEFAULT: '#161616',
    },
    white: {
      DEFAULT: '#FFFFFF',
      100: '#FBFBFC',
    },
    gray: {
      DEFAULT: '#DEDEDE',
      100: '#DAE9EF',
      200: '#A7BAC5',
      300: '#5F6974',
      400: '#E0E0E0',
      500: '#F2F2F2',
      550: '#F5F5F5',
      600: '#EBEBEC',
      700: '#707070',
    },
    blue: {
      DEFAULT: '#2F80ED',
      100: '#197CBD',
      200: '#EFF5FF',
      300: '#1773B0',
    },
    green: {
      DEFAULT: '#DBFAE2',
      100: '#B9DDC2',
      200: '#3E734C',
      300: '#ECF9F1',
    },
    orange: {
      DEFAULT: '#F2C94C',
    },
  },
  spacing: {
    none: '0px',
    nano: '2px',
    '2xs': '4px',
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
    '2xl': '40px',
  },
  border: {
    radius: {
      DEFAULT: '0.25rem',
      none: '0px',
      sm: '0.125rem',
      md: '0.375rem',
      lg: '0.5rem',
      xl: '0.75rem',
      '2xl': '1rem',
      '3xl': '1.5rem',
      full: '9999px',
    },
  },
  screens: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: 1280,
  },
};

export default theme;
